<template>
	<!-- 商户进件 -->
	<div class="merchantList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="searchForm" class="demo-form-inline">
				<el-form-item>
					<el-input size clearable v-model="searchForm.merchant_name" placeholder="请输入商户名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="searchForm.mobile" placeholder="请输入商户手机号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="searchForm.merchant_no" placeholder="请输入商户编号"></el-input>
				</el-form-item>

				<el-form-item>
					<el-select size v-model="searchForm.status" clearable placeholder="请选择审核状态">
						<el-option label="审核通过" value="1"></el-option>
						<el-option label="审核未通过" value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="searchForm.parent_user_phone" placeholder="请输入直属代理商账号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="searchForm.second_user_phone" placeholder="请输入所属代理商账号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-date-picker v-model="rangeDate" type="datetimerange" range-separator="至"
						start-placeholder="申请开始日期" end-placeholder="申请结束日期" value-format="yyyy-MM-dd"
						@change="pickerChange"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(searchForm)">查询</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<div style="margin-bottom: 10px;">
							<div class="tableTitle">
								<span class="st-label">商户总数：</span>
								<span class="st-word-aux">{{success_count}}</span>
							</div>
						</div>
			<el-table :data="marchantList" size="mini" border style="width: 100%" v-loading="loading">
				<!-- 序号 -->
				<el-table-column header-align="center" align="center" fixed type="index" label="ID"
					min-width="80"></el-table-column>

				<el-table-column header-align="center" align="center" prop="short_name" label="商户名称"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="mobile" label="商户手机号"min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="merchant_no" label="商户编号"min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="parent_real_name" label="直属代理商姓名"min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="parent_phone" label="直属代理商账号"min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="second_real_name" label="所属代理商名称"min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="second_phone" label="所属代理商账号"min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="is_sync" label="审核状态" min-width="120"></el-table-column>


				<el-table-column header-align="center" align="center" prop="mpos_time" label="审核时间"
					min-width="150"></el-table-column>
				<el-table-column header-align="center" align="center" prop="create_time" label="审核时间"
					min-width="150"></el-table-column>
				<!-- 操作 -->
				<el-table-column header-align="center" align="center" fixed="right" label="操作" min-width="150">
					<template slot-scope="scope">
						<el-button @click="handleInfo(scope.row)" type="text" size="small">详情</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页部分 -->
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:page-sizes="[10,20,50,100]" :current-page="currentPage" :page-size="pageSize" :total="total"
				layout="total, sizes, prev, pager, next, jumper"></el-pagination>
		</el-card>
	</div>
</template>

<script>
	export default {
		name: "merchant-net",
		data() {
			return {
				isAdd: false, //
				toolsIsShow: false, //修改代理商
				searchForm: {
					merchant_name: '',
					mobile: '',
					merchant_no: '',
					parent_user_phone: '',
					second_user_phone: '',
					status: '',
					start_time: '',
					end_time: '',
				},
				rangeDate: '',
				id: '',
				marchantList: [],
				currentPage: 1, //当前页码
				pageSize: 10, //条数
				total: 0, //总数
				success_count:0,
				loading: true,
				level: sessionStorage.getItem('level'),
				dialogData: {
					data: {} //当前行的数据
				},
			}
		},
		created() {

		},
		mounted() {
			this.getData({
				page: 1,
				limit: 10
			})
		},
		methods: {
			onSearch(searchFrom) {
				this.currentPage = 1;
				searchFrom.page = 1;
				this.getData(searchFrom);
			},
			getData(params) { //获取数据
				this.loading = true;
				this.$api.post("merchant/merchant_mpos_list", params, res => {
					let data = res.data;
					this.total = data.count; //总数
					this.marchantList = res.data.list;
					this.success_count = data.success_count;
					//渲染结束后取消加载
					this.loading = false;
				})
			},
			handleCurrentChange(page) { //当前选中页
				this.currentPage = page;
				this.searchForm.page = page;
				this.searchForm.limit = this.pageSize;
				this.getData(this.searchForm);
			},
			handleSizeChange(limit) { //条数
				this.currentPage = 1;
				this.pageSize = limit;
				this.searchForm.page = 1;
				this.searchForm.limit = limit;
				this.getData(this.searchForm);
			},
			handleInfo(row) { //详情
				this.$router.push({
					path: '/mobilePOSMerchantInfo',
					query: {
						id: row.merchant_id,
					}
				});
			},
			pickerChange(DateArr) { //时间选择器
				this.searchForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
				this.searchForm.end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
			},
			
		}
	}
</script>

<style scoped lang="scss">
	.merchantList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}
	}
</style>